'use client';

import {usePathname, useRouter} from '@/i18n/navigation';
import clsx from 'clsx';
import {useLocale, useTranslations} from 'next-intl';
import Image from 'next/image';
import {useParams} from 'next/navigation';
import {ReactNode, useTransition} from 'react';

type Props = {
  children: ReactNode;
  defaultValue: string;
};

export default function LocaleSwitcherBtn({children, defaultValue}: Props) {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();
  const pathname = usePathname();
  const params = useParams();
  const t = useTranslations('LocaleSwitcher');
  const locale = useLocale();

  return (
    <label
      className={clsx(
        'relative text-gray-400',
        isPending && 'transition-opacity [&:disabled]:opacity-30'
      )}
    >
      <button
        onClick={() => {
          startTransition(() => {
            const nextLocale = locale === 'zh' ? 'en' : 'zh';
            const searchQuery = window.location.search;
            if (nextLocale == 'en') {
              router.replace(
                // @ts-expect-error -- TypeScript will validate that only known `params`
                // are used in combination with a given `pathname`. Since the two will
                // always match for the current route, we can skip runtime checks.
                {pathname: `${pathname}${searchQuery}`, params},
                {locale: nextLocale}
              );
              router.refresh();
            } else {
              router.replace(
                // @ts-expect-error -- TypeScript will validate that only known `params`
                // are used in combination with a given `pathname`. Since the two will
                // always match for the current route, we can skip runtime checks.
                {pathname: `${pathname}${searchQuery}`, params},
                {locale: nextLocale}
              );
              router.refresh();
            }
          });
        }}
        title={t('label')}
        className="questrial bg-[#e22319] hover:opacity-70 text-white h-[30px] px-[16px] rounded-full text-[14px] flex gap-2 items-center"
      >
        <Image src={`/img/asw-language-w.svg`} alt="" width={16} height={16} />
        <span className="h-[30px]">{t('nextLang')}</span>
      </button>
    </label>
  );
}
